module.exports = __webpack_public_path__ + "static/media/messaging-pagination.6d4c40d7.png";